var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-20"
  }, [_c('v-row', {
    staticClass: "row--x-small",
    attrs: {
      "justify": "end"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "9",
      "sm": "10",
      "md": "auto"
    }
  }, [_c('v-text-field', {
    staticClass: "w-100 min-w-md-300px",
    attrs: {
      "placeholder": "검색어를 입력하세요.",
      "hide-details": "",
      "outlined": ""
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return function () {
          _vm.search(true);
        }($event);
      }
    },
    model: {
      value: _vm.filter.searchValue,
      callback: function callback($$v) {
        _vm.$set(_vm.filter, "searchValue", $$v);
      },
      expression: "filter.searchValue"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "3",
      "sm": "2",
      "md": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "h-100 w-100 w-md-100px color-white",
    attrs: {
      "color": "grey-7"
    },
    on: {
      "click": function click($event) {
        return _vm.search();
      }
    }
  }, [_vm._v("검색")])], 1)], 1)], 1), _c('div', {
    staticClass: "pt-12 pt-lg-36 border-top border-color-black border-2 w-100"
  }, [_c('v-row', _vm._l(_vm.boards, function (board, idx) {
    return _c('v-col', {
      key: idx,
      attrs: {
        "cols": "6",
        "md": "3"
      }
    }, [_c('a', {
      staticClass: "board-item d-block border border-color-light",
      attrs: {
        "href": board.meta.href,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "thumb-wrap"
    }, [_c('div', {
      staticClass: "thumb",
      style: "background-image: url(".concat(board.thumb, ")")
    })]), _c('div', {
      staticClass: "board-item__txt pa-20 px-md-22"
    }, [_c('p', {
      staticClass: "page-text--sm board-item__txt__tit mb-10 mb-lg-24"
    }, [_vm._v(" " + _vm._s(board.subject) + " ")]), _c('p', {
      staticClass: "font-size-12 font-size-lg-14 line-height-1 color-grey-a"
    }, [_vm._v(" " + _vm._s(board.createdAt.toDate()) + " ")])])])]);
  }), 1)], 1), _c('div', {
    staticClass: "mt-50 mt-lg-80"
  }, [_c('v-pagination', {
    attrs: {
      "length": _vm.pageCount,
      "total-visible": 11
    },
    on: {
      "input": function input($event) {
        return _vm.search();
      }
    },
    model: {
      value: _vm.page,
      callback: function callback($$v) {
        _vm.page = $$v;
      },
      expression: "page"
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }